import { combineReducers } from 'redux';

import select from 'modules/global/reducers/generic.selectSlice';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import { FETCH_TAGS } from 'modules/tags/actionTypes';

import dashboard from './dashboard';
import details from './details';

/**
 * @typedef {{
 *   dashboard: import('./dashboard').TagsUIDashboardReducer,
 *   details: import('./details').TagsUIDetailsReducer,
 *   select: import('modules/global/reducers/generic.selectSlice').GenericSelectsReducer
 * }} TagsUIReducer
 */

export default combineReducers({
  dashboard,
  details,
  select: select(FETCH_TAGS, {
    global: { matcher: ({ meta }) => Boolean(meta?.selectId) },
    matchers: [{
      matcher: ({ type, payload }) => type === LOCATION_CHANGE && payload.action !== 'REPLACE',
      reducer: () => ({}),
    }]
  })
});
